var map = {
	"./categories/carousel/banking-and-finance.jpg": 6919,
	"./categories/carousel/business-innovation.jpg": 7214,
	"./categories/carousel/companies.jpg": 865,
	"./categories/carousel/countries-and-cultures.jpg": 5640,
	"./categories/carousel/economy.jpg": 8024,
	"./categories/carousel/education-and-corporate-training.jpg": 7577,
	"./categories/carousel/education.jpg": 1226,
	"./categories/carousel/employment.jpg": 6032,
	"./categories/carousel/environment.jpg": 7291,
	"./categories/carousel/finance-and-money.jpg": 4645,
	"./categories/carousel/government-and-law.jpg": 3560,
	"./categories/carousel/industries.jpg": 7204,
	"./categories/carousel/international-politics.jpg": 5846,
	"./categories/carousel/internet-and-new-economy.jpg": 4019,
	"./categories/carousel/internet-and-technology.jpg": 2310,
	"./categories/carousel/management.jpg": 959,
	"./categories/carousel/marketing.jpg": 2080,
	"./categories/carousel/media.jpg": 5756,
	"./categories/carousel/news.jpg": 375,
	"./categories/carousel/people.jpg": 383,
	"./categories/carousel/science.jpg": 5374,
	"./categories/carousel/society-and-the-wider-world.jpg": 5957,
	"./categories/carousel/technology-and-innovation.jpg": 2854,
	"./categories/carousel/transport-and-travel.jpg": 4666,
	"./categories/carousel/working-practices.jpg": 0,
	"./categories/headers/banking-and-finance.jpg": 3951,
	"./categories/headers/business-innovation.jpg": 4070,
	"./categories/headers/companies.jpg": 169,
	"./categories/headers/countries-and-cultures.jpg": 1984,
	"./categories/headers/economy.jpg": 3280,
	"./categories/headers/education-and-corporate-training.jpg": 8993,
	"./categories/headers/education.jpg": 4290,
	"./categories/headers/employment.jpg": 5928,
	"./categories/headers/environment.jpg": 3491,
	"./categories/headers/finance-and-money.jpg": 8013,
	"./categories/headers/government-and-law.jpg": 2176,
	"./categories/headers/industries.jpg": 7436,
	"./categories/headers/international-politics.jpg": 6014,
	"./categories/headers/internet-and-new-economy.jpg": 8235,
	"./categories/headers/internet-and-technology.jpg": 1822,
	"./categories/headers/management.jpg": 3543,
	"./categories/headers/marketing.jpg": 1432,
	"./categories/headers/media.jpg": 6740,
	"./categories/headers/news.jpg": 2367,
	"./categories/headers/people.jpg": 167,
	"./categories/headers/science.jpg": 214,
	"./categories/headers/society-and-the-wider-world.jpg": 8717,
	"./categories/headers/technology-and-innovation.jpg": 7470,
	"./categories/headers/transport-and-travel.jpg": 9282,
	"./categories/headers/working-practices.jpg": 3192,
	"./logo.png": 7015,
	"./profile.png": 6759
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8257;